'use client';
import { useLocale, useTranslations } from 'next-intl';

import UserMenu from 'components/Header/UserMenu';
import useParams from 'hooks/useParams';
import BreadcrumbWrapper from 'ui/BreadcrumbWrapper';
import { TenantDetailsResponse, UserResponse } from 'utils/GeneratedApi';
import getBredCumbName from 'utils/getBredCumbName';
import getBredCumbPathLink from 'utils/getBredCumbPathLink';

type BreadcrumbHeaderProps = {
  user: UserResponse;
  tenant: TenantDetailsResponse;
};

function BreadcrumbHeader({ user, tenant }: BreadcrumbHeaderProps) {
  const tBreadCrumb = useTranslations('breadcumb');
  const tProfile = useTranslations('customerProfile');

  const { params } = useParams();
  const locale = useLocale();

  const filteredParams = params?.filter((path) => path !== locale).slice(0, 2);

  const breadcrumbs = filteredParams?.map((path, index) => {
    const href = getBredCumbPathLink(filteredParams, index);
    let name = getBredCumbName(path);

    name = tBreadCrumb(name);

    return {
      href,
      name,
      targetElement: '',
    };
  });

  return (
    <nav className="flex justify-center items-center w-full bg-white border-b-[1px] border-[var(--themeBorderColor)]">
      <div className="flex justify-between items-center max-w-7xl w-full h-16 px-4 md:px-36 py-2.5">
        <div className="flex justify-start items-center">
          {breadcrumbs.length > 1 ? (
            <BreadcrumbWrapper navigationItems={breadcrumbs} />
          ) : (
            <h1 className="my-2 mr-2 text-2xl font-bold text-black">{tProfile('title')}</h1>
          )}
        </div>
        <UserMenu user={user} tenant={tenant} />
      </div>
    </nav>
  );
}

export default BreadcrumbHeader;
